<div class="horizinns-container center horizinns-main-container-padding">
    <img src="/assets/images/logo_full_900.png" style="width:40%;" class="main-logo" alt="Horizinns logo"/>
    <h1>Common Forms</h1>
    <!-- <mat-card class="horizinns-card even-more-blur white-blur mw-40">
        <mat-card-content class="content">
        </mat-card-content>
    </mat-card> -->

    <div class="common-forms-list-container">

        <mat-card class="form-link-card even-more-blur white-blur">
            <mat-card-header>
                <i class="fa-solid fa-file-pdf"></i>
                <h3>Property Host - Sales Agent Listing Form</h3>
            </mat-card-header>
            <img src="/assets/images/sales_listing_preview.png" style="width: 100%;" alt="Preview of Sales Listing Form"/>
            <mat-card-actions align="end">
                <button mat-mini-fab class="menu-button metallic-bubble-btn-green" (click)="openListingForm()">
                    <mat-icon>arrow_forward_ios</mat-icon>
                </button>
            </mat-card-actions>
        </mat-card>
    
        <mat-card class="form-link-card even-more-blur white-blur">
            <mat-card-header>
                <i class="fa-solid fa-file-pdf" style="font-size: 40px; width: 40px; height: 40px; opacity: 0.9; color: #028da8;"></i>
                <h3>Sales Agent - Structure Terms Agreement Form</h3>
            </mat-card-header>
            <img src="/assets/images/sales_terms_preview.png" alt="Preview of Sales Terms Agreement Form"/>
            <mat-card-actions align="end">
                <button mat-mini-fab class="menu-button metallic-bubble-btn-green" (click)="openTermsForm()">
                    <mat-icon>arrow_forward_ios</mat-icon>
                </button>
            </mat-card-actions>
        </mat-card>

        <mat-card class="form-link-card even-more-blur white-blur">
            <mat-card-header>
                <i class="fa-solid fa-file-pdf" style="font-size: 40px; width: 40px; height: 40px; opacity: 0.9; color: #028da8;"></i>
                <h3>Sales Agent - W9 Tax Form</h3>
            </mat-card-header>
            <img src="/assets/images/sales_w9_preview.png" alt="Preview of W9 Form"/>
            <mat-card-actions align="end">
                @if (currentUser()?.role !== 'sales' && currentUser()?.role !== 'admin') {
                    <mat-icon matTooltip="Sales Agent Structure Terms Agreement form must be approved to unlock this form">lock</mat-icon>
                } @else {
                    <button mat-mini-fab class="menu-button metallic-bubble-btn-green" (click)="openW9Form()" [disabled]="currentUser()?.role !== 'sales' && currentUser()?.role !== 'admin'">
                        <mat-icon>arrow_forward_ios</mat-icon>
                    </button>
                }
            </mat-card-actions>
        </mat-card>
    </div>
</div>
